/* eslint-disable max-lines */
import React from 'react';

import { IFAQBlock } from '../FAQSectionContainer';

//TODO: Убрать тоггл в задаче CD-187369

export interface IFAQOptions {
  isAbsolutBankEnabled: boolean;
}

export const getFAQBlocks = ({ isAbsolutBankEnabled }: IFAQOptions): IFAQBlock[] => [
  {
    name: 'Про возможности сделки',
    questions: [
      {
        question: 'Могут ли покупатель и продавец самостоятельно провести сделку через сервис «Циан.Сделка»?',
        answer: `Нет, воспользоваться сервисом «Циан.Сделка» без профессионального участника рынка невозможно.`,
      },
      {
        question: 'Сколько занимает электронная регистрация права собственности?',
        answer: (
          <>
            Электронная регистрация перехода права собственности через сервис «Циан.Сделка» в среднем занимает 5 рабочих
            дней: ~2 дня — доставка электронных подписей представителем удостоверяющего центра и подписание документов;
            ~3 дня — регистрация перехода права собственности в Росреестре. При этом по закону{' '}
            <a
              href="https://rosreestr.gov.ru/press/archive/publications/sroki-registratsii-ischislyayutsya-v-rabochikh-dnyakh/"
              target="_blank"
              rel="noreferrer"
            >
              регистрация в Росреестре может идти до 7 рабочих дней включительно
            </a>
            .
          </>
        ),
      },
      {
        question: 'Можно ли через Циан.Сделку оформить покупку / продажу дома с земельным участком?',
        answer: `На данный момент через Циан.Сделку можно зарегистрировать дом и земельный участок, на котором он стоит, подав 2 отдельные заявки на сделку подряд. Расчёт возможен любым другим способом вне нашего сервиса (банковская ячейка, наличные, аккредитивы в офисах банков, СБР других сервисов и т.д.).`,
      },
      {
        question: 'Можно ли через Циан.Сделку оформить переуступку прав требований  квартиры в новостройке?',
        answer: `На данный момент через Циан.Сделку можно зарегистрировать переуступку прав требований  квартиры в новостройке. Для оформления может потребоваться согласие от застройщика (в том случае если в ДДУ прописано, что обмен в электронном виде). Переуступку прав требований можно оформить только между физическими лицами.`,
      },
      {
        question: 'Вы проводите юридическую проверку недвижимости перед электронной регистрацией?',
        answer: (
          <>
            Нет, но вы можете воспользоваться нашим сервисом{' '}
            <a href="https://www.cian.ru/legal-check/" target="_blank" rel="noreferrer">
              «Проверка недвижимости»
            </a>
            . Опытные юристы изучат объект и продавца, расскажут о возможных рисках и помогут их избежать.
          </>
        ),
      },
      {
        question: 'В каких городах вы проводите электронную регистрацию?',
        answer: (
          <>
            Объект недвижимости, с которым проводится сделка, может находиться почти в любой точке РФ. Встречи
            участников сделки с представителем удостоверяющего центра проводятся в большинстве регионов РФ, с полным
            списком городов вы можете ознакомиться{' '}
            <a href="https://hc.cian.ru/hc/ru/articles/4408340109204" target="_blank" rel="noreferrer">
              по ссылке
            </a>
            .
          </>
        ),
      },
      {
        question: 'Какие еще есть ограничения на проведение электронной регистрации с помощью сервиса «Циан.Сделка»?',
        answer: (
          <>
            <p>
              Мы не регистрируем объекты, находящиеся под обременением, в том числе в залоге у банка. Также не
              регистрируем цепочки связанных (альтернативных) сделок в рамках одной услуги, но вы можете
              зарегистрировать несколько последовательных сделок по отдельности.{' '}
            </p>
            <p>Типы объектов недвижимости, с которыми мы проводим сделки:</p>
            <ul>
              <li>квартира на вторичном рынке;</li>
              <li>апартаменты;</li>
              <li>комната на вторичном рынке;</li>
              <li>гараж;</li>
              <li>машино-место;</li>
              <li>жилой дом;</li>
              <li>
                земельный участок, предназначенный для ведения личного подсобного, дачного хозяйства, огородничества,
                садоводства, индивидуального гаражного или индивидуального жилищного строительства;
              </li>
              <li>коммерческая недвижимость (торговая площадь, склад, помещение свободного назначения, здание);</li>
              <li>постройки: садовый дом, баня, сарай.</li>
            </ul>
            <p>При этом объект недвижимости:</p>
            <ul>
              <li>не находится в залоге;</li>
              <li>не приобретен за счет средств материнского (семейного) капитала;</li>
              <li>право собственности на него возникло после 31.01.1998 г.</li>
            </ul>
            <p>
              Услуга СБР не оказывается по Сделкам, где Объектами в рамках одной Сделки выступают земельный участок и
              гараж/жилой дом/хозяйственные постройки.
            </p>
            <p>
              Участником сделки может выступать дееспособный гражданин Российской Федерации, достигший 18 лет. У всех
              участников обязательно должны быть смартфоны, на которые можно установить специальное приложение для
              электронной подписи документов. В смартфоне должна быть установлена сим-карта с номером мобильного
              телефона, которой был указан в заявке на регистрацию.
            </p>
            <p>
              В сделке могут принимать участие не более 10 покупателей и 10 продавцов. Без участия законных
              представителей и\или представителей участников сделки, действующих по доверенности.
            </p>
            <p>
              При этом у собственника отсутствует запрет на проведение сделки в электронном виде, а покупатель должен
              оплачивать объект недвижимости без использования заемных денежных средств (ипотеки) или средств
              материнского (семейного) капитала.
            </p>
            <p>
              Оплатить услугу «Циан.Сделка» можно только онлайн. Ссылка на оплату отправляется покупателю после
              оформления заявки на сделку.
            </p>
          </>
        ),
      },
      {
        question: 'Можно ли провести Циан.сделку если участник находится за пределами РФ?',
        answer: (
          <>
            <p>Можно, но есть ряд ограничений:</p>
            <ul>
              <li>
                у участника сделки должен быть при себе заграничный паспорт нового образца (на 10 лет) и смартфон с
                NFC-модулем;
              </li>
              <li>
                у участника сделки должна быть в наличии активная сим-карта с российским номером (на неё придет смс с
                кодом авторизации);
              </li>
              <li>у участника сделки должно быть цветное изображение паспорта гражданина РФ (фото/скан);</li>
              <li>
                подписание документов будет производиться с помощью приложения «Госключ». Чтобы им воспользоваться у
                клиента должна быть подтверждённая учётная запись на портале Госуслуг.
              </li>
            </ul>
          </>
        ),
      },
      {
        question: 'Сколько участников могут одновременно принимать участие в сделке через сервис Циан.Сделка?',
        answer: 'В сделке пока могут принимать участие не более 10 покупателей и не более 10 продавцов.',
      },
      {
        question: 'Дарение возможно подать на регистрацию через Циан.Сделку?',
        answer: 'Сделки по дарению пока не проводим. ',
      },
      {
        question:
          'Можно ли зарегистрировать цепочки из сделок с возможностью их одновременного рассмотрения одним сотрудником Росреестра?',
        answer: 'Нет, т.к. такое действие незаконно, но мы можем зарегистрировать отдельно все ваши сделки в цепочке.',
      },
    ],
  },
  {
    name: 'Про безопасность',
    questions: [
      {
        question: 'Электронные подписи безопасны?',
        answer: (
          <>
            <p>
              Короткий ответ: да. Такие подписи создаются с помощью криптографических методов защиты, подделать их почти
              невозможно — в отличии от обычных подписей ручкой.
            </p>
            <p>
              Для сделки используются усиленные квалифицированные электронные подписи — их выдают только удостоверяющие
              центры с аккредитацией Минцифры РФ.
            </p>
          </>
        ),
      },
      {
        question: 'У приложения для подписания документов низкий рейтинг. Оно безопасно?',
        answer:
          'Подписание документов через приложение безопасно. Низкий рейтинг обусловлен циклом использования приложения. Пользователь устанавливает его, подписывает документы и сразу удаляет. Магазины приложений Play Market и AppStore автоматически снижают за это рейтинги.',
      },
      {
        question: 'Как можно проводить сделки, не видя очно продавца и покупателя? Это небезопасно!',
        answer:
          'Подписать документы электронными подписями смогут только участники сделки, которым они принадлежат. Подписание будет происходить в специальном приложении, куда мы вышлем документы, необходимые для проведения регистрации. Документы в Росреестр отправим, когда все участники сделки их подпишут.',
      },
      {
        question: 'Зачем нужна видеовстреча с представителем банка?',
        answer: isAbsolutBankEnabled /* istanbul ignore next */
          ? 'На онлайн-встрече в Zoom представитель одного из банков-партнёров — Точка или Абсолют — проверяет паспорта участников сделки и задаёт им вопросы по значимым тезисам ДКП. Это нужно для выдачи уведомления об участии банка в сделке — без него она будет считаться незаконной.'
          : 'На онлайн-встрече в Zoom представитель банка Точка идентифицирует личности и проверяет паспорта участников и задаёт вопросы по значимым тезисам ДКП. Это нужно для выдачи «Уведомления об участии банка» по сделке в соответствии с № 218-ФЗ. Без этого документа провести сделку не получится.',
      },
    ],
  },
  {
    name: 'Про взаиморасчёты',
    questions: [
      {
        question: 'Можно ли использовать реквизиты родственников в сервисе безопасных расчётов от Циан?',
        answer:
          'Нет. Счёт, на который Циан переведёт деньги за объект недвижимости, должен быть открыть строго на одного из продавцов. Циан не будет переводить деньги на реквизиты супруга продавца, родственника или прочих третьих лиц, не являющихся сторонами сделки по договору купли-продажи.',
      },
      {
        question: 'Как произвести расчёт через электронный аккредитив от СберБанка',
        answer: (
          <>
            <p>
              Риелтор, который ведёт сделку со стороны покупателя или продавца, подаёт заявку на сделку в сервисе
              Циан.Сделка в своём личном кабинете. Циан, в свою очередь, передаёт данные для открытия аккредитива по
              защищённому каналу в СберБанк.
            </p>
            <p>
              Покупатель получает от СберБанка смс со ссылкой и за пару кликов подписывает заявку на открытие
              аккредитива в мобильном приложении СберБанк Онлайн. Чтобы воспользоваться услугой, покупателю обязательно
              нужно быть клиентом СберБанка и пользователем мобильного приложения СберБанк Онлайн.
            </p>
            <p>
              Покупатель оплачивает услугу в размере 2 000 ₽ в момент открытия аккредитива в мобильном приложении
              СберБанк Онлайн. Перевести деньги за недвижимость на счёт аккредитива можно бесплатно со сберегательного
              счёта. После перевода средств на счёт аккредитива продавцу придёт смс от СберБанка об открытии
              аккредитива.
            </p>
            <p>
              После выполнения условий аккредитива СберБанк переведёт деньги продавцу в течение одного рабочего дня.
              Платёжные документы, подтверждающие перевод денежных средств продавцу, можно скачать в приложении СберБанк
              Онлайн.
            </p>
            <p>
              Если сделка не состоится, закрыть аккредитив можно в любое время. Покупатель может подать заявление на
              отзыв аккредитива в мобильном приложении СберБанк Онлайн или в любом офисе СберБанка. Денежные средства
              будут возвращены покупателю когда продавец подтвердит свое согласие на отзыв в мобильном приложении
              СберБанк Онлайн или в любом офисе СберБанка.
            </p>
          </>
        ),
      },
    ],
  },
  {
    name: 'Про электронную подпись',
    questions: [
      {
        question: 'Электронные подписи безопасны?',
        answer: (
          <>
            <p>
              Короткий ответ: да. Такие подписи создаются с помощью криптографических методов защиты, подделать их почти
              невозможно — в отличии от обычных подписей ручкой.
            </p>
            <p>
              Для сделки используются усиленные квалифицированные электронные подписи — их выдают только удостоверяющие
              центры с аккредитацией Минцифры РФ.
            </p>
          </>
        ),
      },
      {
        question: 'Как можно активировать электронную подпись по загранпаспорту?',
        answer:
          'В загранпаспорте нового образца есть биометрический чип. Приложение «Госключ» сканирует чип с помощью технологии NFC в смартфоне, и удостоверив личность, выпускает квалифицированную электронную подпись. Также для выпуска такой подписи в приложении «Госключ» нужна подтвержденная учётная запись на портале Госуслуг.',
      },
      {
        question: 'Можно ли  заранее ознакомиться с документами, направляемыми на подписание в приложение?',
        answer:
          'Да, одно из преимуществ нашего сервиса в том, что участники сделки могут спокойно и не торопясь ознакомиться с документами, которые направляются им на подписание в мобильное приложение. Если нужно заменить документы, напишите  об этом персональному менеджеру: он направит вам на подписание скорректированные документы.',
      },
    ],
  },
  {
    name: 'Другое',
    questions: [
      {
        question: 'Моим клиентам нужны документы с синими печатями',
        answer:
          'Документы, подтверждающие регистрацию перехода права собственности, Росреестр отправляет в электронном виде. Как правило, нет необходимости в бумажной версии документов. Но вы всегда можете получить отождествление у нотариуса — это просто, быстро и недорого.',
      },
      {
        question: 'У меня есть вопросы по документам, статусам и срокам сделки. Кому мне их задать?',
        answer: (
          <>
            <p>
              Каждому клиенту, который завёл заявку на сделку, мы назначаем персонального менеджера. Он проконсультирует
              по любому вопросу, связанному со сделкой, объяснит все шаги и нюансы, поможет с документами. В нашем
              сервисе сделку ведёт один персональный менеджер от начала и до конца: мы не будем перебрасывать вас от
              одного сотрудника к другому.
            </p>
            <p>
              Если вы ещё не завели заявку на сделку, то наши специалисты с радостью вас проконсультируют по любому
              вопросу в чате или по электронной почте support-deal@cian.ru с 7 до 18 по московскому времени.
            </p>
          </>
        ),
      },
    ],
  },
];
